// Regras de senha (iguais às do Auth): 12+ caracteres, maiúscula, minúscula, número e símbolo.
export interface PasswordChecks {
  length: boolean;
  upper: boolean;
  lower: boolean;
  digit: boolean;
  symbol: boolean;
  ok: boolean;
}

export function checkPassword(pw: string): PasswordChecks {
  const length = [...pw].length >= 12;
  const upper = /\p{Lu}/u.test(pw);
  const lower = /\p{Ll}/u.test(pw);
  const digit = /\p{Nd}/u.test(pw);
  const symbol = /[^\p{L}\p{Nd}]/u.test(pw);
  return { length, upper, lower, digit, symbol, ok: length && upper && lower && digit && symbol };
}
